import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { SalesDocumentTemplateCreateModal } from './SalesDocumentTemplateCreateModal'

type SalesDocumentTemplateCreateActivityProps = {
  refetchQuery: string
  legalEntityId?: string
}

export const SalesDocumentTemplateCreateActivity: ActivityComponent<
  SalesDocumentTemplateCreateActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <SalesDocumentTemplateCreateModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      legalEntityId={data.legalEntityId ? String(data.legalEntityId) : undefined}
    />
  )
}
